module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.a-function.js
// module id = 21
// module chunks = 0